/* eslint-env browser */
import { ExplicitContext, Tracer, BatchRecorder } from 'zipkin';
import { HttpLogger } from 'zipkin-transport-http';

// Send spans to Zipkin asynchronously over HTTP

const ctxImpl = new ExplicitContext();

const zipkinBaseUrl = 'http://localhost:9411';

const createRecorder = () => new BatchRecorder({
  logger: new HttpLogger({
    endpoint: `${window.zipkinServerUrl || zipkinBaseUrl}/api/v1/spans`
  })
});
const createTracer = () => new Tracer({ ctxImpl, recorder: createRecorder() });
export { createRecorder, createTracer };
